<app-breadcrumb
  [title]="repository.title"
  [items]="repository.breadcrumbs"
></app-breadcrumb>

<div class="section">
  <div class="section-content">
    <div class="grid justify-content-center">
      <div class="grid-item grid-8 grid-sm-12">
        <div class="hidden-sm typography typography-h3 typography-x-center">
          Анализы в Лабораторной службе Хеликс можно выполнить по полису
          добровольного медицинского страхования (ДМС). Чтобы воспользоваться
          полисом ДМС:
        </div>
        <div
          class="hidden block-sm typography typography-headline typography-x-center mb-40"
        >
          Анализы в Лабораторной службе Хеликс можно выполнить по полису
          добровольного медицинского страхования (ДМС). Чтобы воспользоваться
          полисом ДМС:
        </div>
      </div>
    </div>

    <div class="grid justify-content-center">
      <div class="grid-item grid-9 grid-sm-12 grid-lg-10">
        <app-numbered-steps [steps]="repository.steps"></app-numbered-steps>
      </div>
    </div>
  </div>
</div>

<div class="section mt-80">
  <div class="section-content">
    <div class="typography typography-h3 typography-paragraph">
      Страховые компании, с&nbsp;которыми работает Хеликс:
    </div>

    <div class="hidden-sm">
      <div class="grid grid-gutter-16">
        <app-dms-company
          class="grid-item grid-3 grid"
          *ngFor="let company of repository.listCompanies"
          [company]="company"
        ></app-dms-company>
      </div>
    </div>

    <div class="hidden block-sm">
      <div class="grid grid-gutter-16">
        <app-dms-company
          class="grid-item grid-6 grid"
          *ngFor="
            let company of repository.listCompanies.slice(0, logosVisibleMobile)
          "
          [company]="company"
        ></app-dms-company>

        <div class="grid-item grid-12">
          <div
            *ngIf="hasHiddenLogos"
            (click)="showMore()"
            class="button button-subtle button-bordered full-width mb-28"
          >
            Показать ещё ↓
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
